<template lang="pug">
el-table(:data="owners" cell-class-name="el-table-cell" row-class-name="el-table-row" v-loading="loading")
  .empty(slot="empty")
    img(:src="images.group_empty")
    p(v-html="nl2br($t('Cuona.Event.description07'))")
    template(v-if="edit==true")
      el-button(type="info" size="mini" @click="$emit('openDialog')") {{ $t('Cuona.Group.set_group') }}
    template(v-else)
      el-button(type="info" size="mini" @click="$emit('openCreateDialog')") {{ $t('Cuona.Group.set_group') }}
  el-table-column(width="150px" prop="humanized_id" :label="$t('Owners.company.humanized_id')" sortable="")
  el-table-column(width="250px" prop="name" :label="$t('Owners.company.name')" sortable="")
    template(slot-scope="props")
      ruby {{ props.row.name }}
        rt {{ props.row.name_kana }}
  template(v-if="edit==false")
    el-table-column(width="140px" prop="type" :label="$t('Owners.company.type')" sortable="" align="center")
      template(slot-scope="props")
        span {{ showType(props.row.type)  }}
  el-table-column(prop="is_active" width="110px" align="center" :label="$t('Owners.company.is_active')")
    template(slot-scope="props")
      el-tag(:type="makeStatusCss(props.row.is_active)" size="small") {{ showStatus(props.row.is_active) }}
  el-table-column(prop="description" :label="$t('Owners.company.note')")
  el-table-column(width="100px" align="center")
    template(slot-scope="props")
      router-link(:to="{name:'owner', params:{id:props.row.humanized_id}}")
        i.setting.el-icon-setting
        | {{ $t('Owners.company.detail') }}
</template>

<script>
import ownerType from '@/utils/defines/owner'
export default {
  mixins: [ownerType],
  data () {
    return {
      images: {
        group_empty: require('@/assets/empty_event_group.svg')
      }
    }
  },
  props: {
    owners: Array,
    edit: Boolean,
    loading: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    showStatus(is_active) {
      return is_active ? this.$t('Owners.company.active') : this.$t('Owners.company.deactive')
    },
    makeStatusCss(is_active) {
      return is_active ? 'success' : 'danger'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
@import "../../styles/table-layout.scss";

</style>
